module.exports = __webpack_public_path__ + "assets/img/4.155297a2.png";